module.exports = __webpack_public_path__ + "img/cleaf3.9a726e16.jpg";